<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>

      <el-input class="filter-item" v-model="listQuery.name" placeholder="支付通道名称" style="width: 220px;" clearable/>

      <el-select v-model="listQuery.is_on" placeholder="状态" style="width: 120px" class="filter-item" size="small" clearable>
        <el-option label="下架" :value="0" />
        <el-option label="正常" :value="1" />
      </el-select>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="包餐套餐名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="开始日期" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.start_date }}
        </template>
      </el-table-column>

      <el-table-column label="结束日期" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_date }}
        </template>
      </el-table-column>

      <el-table-column label="早餐次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.breakfast_num }}
        </template>
      </el-table-column>

      <el-table-column label="午餐次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.lunch_num }}
        </template>
      </el-table-column>

      <el-table-column label="晚餐次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.dinner_num }}
        </template>
      </el-table-column>

      <el-table-column label="价格" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>

      <el-table-column label="赠送优惠券额度" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.coupon_limit }}
        </template>
      </el-table-column>

      <el-table-column label="购买人数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.orderPayCount }}
        </template>
      </el-table-column>

      <el-table-column label="购买总额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.orderPayMoney }}
        </template>
      </el-table-column>

      <el-table-column label="权重" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.weight }}
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on" type="success">正常</el-tag>
          <el-tag v-else type="danger">下架</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>

          <el-button type="success" size="mini" @click="handleCateredProductOrder(scope.row)">查看购买列表</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="包餐套餐名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="有效时间">
          <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
        </el-form-item>

        <el-form-item label="早餐次数" prop="breakfast_num">
          <el-input-number v-model="form.breakfast_num" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="午餐次数" prop="lunch_num">
          <el-input-number v-model="form.lunch_num" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="晚餐次数" prop="dinner_num">
          <el-input-number v-model="form.dinner_num" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="价格" prop="price">
          <el-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="赠送优惠券额度" prop="coupon_limit">
          <el-input-number v-model="form.coupon_limit" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="权重" prop="weight">
          <el-input-number v-model="form.weight" :min="1" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
          <div style="line-height:16px;font-size: 12px;color:red;margin-top:10px;">
            <div>*权重越大，排名越前</div>
          </div>
        </el-form-item>

        <el-form-item label="状态" prop="is_on">
          <el-switch v-model="form.is_on" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          name: "",
          is_on: "",
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          id: "",
          school_id: "",
          name: "",
          start_date: "",
          end_date: "",
          breakfast_num: undefined,
          lunch_num: undefined,
          dinner_num: undefined,
          price: undefined,
          coupon_limit: undefined,
          weight: 1,
          is_on: 1,
        },
        rules: {
          name: [{ required: true, message: "包餐套餐名不能为空", trigger: "change" }],
          breakfast_num: [{ required: true, message: "早餐次数不能为空", trigger: "blur" }],
          lunch_num: [{ required: true, message: "午餐次数不能为空", trigger: "blur" }],
          dinner_num: [{ required: true, message: "晚餐次数不能为空", trigger: "blur" }],
          price: [{ required: true, message: "价格不能为空", trigger: "blur" }],
          coupon_limit: [{ required: true, message: "赠送优惠券额度不能为空", trigger: "blur" }],
          weight: [{ required: true, message: "权重不能为空", trigger: "blur" }],
          is_on: [{ required: true, message: "状态不能为空", trigger: "blur" }],
        },
        dateArr: null,
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
      },
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.form.start_date = newVal[0];
          this.form.end_date = newVal[1];
        } else {
          this.form.start_date = "";
          this.form.end_date = "";
        }
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/cateredProduct/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          id: "",
          school_id: "",
          name: "",
          start_date: "",
          end_date: "",
          breakfast_num: undefined,
          lunch_num: undefined,
          dinner_num: undefined,
          price: undefined,
          coupon_limit: undefined,
          weight: 1,
          is_on: 1,
        }
        this.btnLoading = false;
        this.dateArr = null;
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.dateArr = [this.form.start_date,this.form.end_date];
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      saveData() {
        this.form.school_id = this.school_id;
        if (!this.form.school_id) {
          this.$message({
            type: "warning",
            message: "请先选择学校"
          });
          return;
        }
        if (!this.form.start_date) {
          this.$message({
            type: "warning",
            message: "开始日期不能为空"
          });
          return;
        }
        if (!this.form.end_date) {
          this.$message({
            type: "warning",
            message: "结束日期不能为空"
          });
          return;
        }

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/cateredProduct/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        })
      },
      handleCateredProductOrder(item) {
        this.$router.push(`/catered/cateredProductOrder?catered_product_id=${item.id}`);
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
